import { skipToken, useQuery } from '@tanstack/react-query'
import type { ECommerceApiListStoresRequest } from '@itsrever/rever-api'
import { ecommerceApi } from '@/infrastructure/api/ecommerce/ecommerce'

export const useStores = ({
  ecommerceId,
  countryCode,
  orderReference
}: Partial<ECommerceApiListStoresRequest>) => {
  return useQuery({
    queryKey: ['stores', ecommerceId, countryCode, orderReference],
    queryFn: ecommerceId
      ? async () => {
          const response = await ecommerceApi.listStores({
            ecommerceId,
            countryCode,
            orderReference
          })

          return response.data
        }
      : skipToken,
    staleTime: Infinity
  })
}
